import React from "react";
import PageShell from "@/components/PageShell";
import { COMPANY } from "@/lib/compliance";

export default function AccessibilityPage() {
    return (
        <PageShell
            testId="page-accessibility"
            kicker="Compliance"
            title="Accessibility Statement"
            seoDescription="Endurance Casualty's accessibility commitments — WCAG 2.1 AA targets, accommodation requests, and how to reach a licensed agent for assisted intake."
            lastUpdated="June 2026"
        >
            <p>
                {COMPANY.fullLegalName} is committed to providing a website
                that is accessible to the widest possible audience,
                regardless of ability or technology. We aim to align this
                website with the Web Content Accessibility Guidelines (WCAG)
                2.2 Level AA.
            </p>

            <h2>What We Do</h2>
            <ul>
                <li>Use semantic HTML and ARIA where appropriate</li>
                <li>Provide visible focus indicators for keyboard navigation</li>
                <li>Support keyboard interaction across menus, dropdowns, and forms</li>
                <li>Pair every form input with a programmatic label</li>
                <li>Provide descriptive alternative text for meaningful images</li>
                <li>Ensure color contrast meets WCAG 2.2 AA</li>
                <li>Test with major screen readers and modern browsers</li>
            </ul>

            <h2>Need Assistance?</h2>
            <p>
                If you have trouble accessing any part of this website, or if
                you would like to request information in an alternative format,
                please contact us. We will do our best to accommodate your needs
                promptly.
            </p>
            <p>
                Phone:{" "}
                <a href={`tel:${COMPANY.phoneTel}`}>{COMPANY.phone}</a>
                <br />
                Email:{" "}
                <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
                <br />
                Mail: {COMPANY.address}
            </p>

            <h2>Reporting an Accessibility Barrier</h2>
            <p>
                We welcome feedback. If you encounter an accessibility barrier
                on this website, please tell us:
            </p>
            <ul>
                <li>The page or feature where you encountered the issue</li>
                <li>What happened, and what you were trying to do</li>
                <li>The browser, operating system, and any assistive technology you were using</li>
                <li>How we can reach you to follow up</li>
            </ul>
            <p>
                We aim to acknowledge every accessibility report within five
                business days and to remediate confirmed issues as promptly as
                practicable.
            </p>

            <h2>Ongoing Effort</h2>
            <p>
                Accessibility is an ongoing process. We periodically review the
                site for issues and update this Statement as we make
                improvements.
            </p>
        </PageShell>
    );
}
